import { Container, Sprite } from 'pixi.js';
import Core from '../../../Core/Core';
import { Collection } from '../../../Tiles/TileSet';
import { getSpriteId } from '../../../Utils/CollectableUtils';
import { createOutlineText } from '../../../Utils/Utils';

export class GoalBanner extends Container {
    private goalIcon: PIXI.Sprite;

    constructor(goalId: string, collection: Collection) {
        super();

        const header = new Sprite(PIXI.utils.TextureCache['commonui/header']);
        header.anchor.set(0.5, 0.5);
        header.scale.set(0.9);
        this.goalIcon = new Sprite(
            PIXI.utils.TextureCache[getSpriteId('commonui/top-hud-goal-icon-' + goalId, collection)]
        );
        this.goalIcon.anchor.set(0.5);
        this.goalIcon.scale.set(1.8);
        this.goalIcon.y = header.y - header.height * 0.4;

        let txt = Core.local.getText('matchtiles');
        if (goalId === 'toys') {
            txt = Core.local.getText('findtoys');
        } else if (goalId === 'gold') {
            txt = Core.local.getText('findgold');
        }

        const goalTxt = createOutlineText(
            txt,
            new PIXI.Rectangle(0, 0, header.width * 0.9, header.height * 0.6),
            'Baloo',
            32,
            28,
            0xffffff,
            0x991f33
        );

        goalTxt.y = this.goalIcon.y + this.goalIcon.height * 0.8;
        this.addChild(header, this.goalIcon, goalTxt);
    }
}
